import type { UserProfile } from '~/shared/api/services/users/types'

const SUPER_ADMINISTRATOR_ROLE = 'super-administrator'

export const hasUserPermission = (
  profile: UserProfile | null | undefined,
  permission: string,
): boolean =>
  Boolean(
    profile?.roles?.some((role) => role.name === SUPER_ADMINISTRATOR_ROLE) ||
    profile?.permissions?.includes(permission) ||
    profile?.roles?.some((role) =>
      role.permissions?.some((item) => item.name === permission),
    ),
  )
